import React, { Fragment, useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "react-moment";
import { Box, Paper, useMediaQuery } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { useTheme } from "@mui/material/styles";
import { useDesignTokens } from "../../theme/useDesignTokens";
import DeviceUsage from "../report/DeviceUsage";
import FirmwareDetails from "../report/FirmwareDetails";
import OnboardedHistory from "../report/OnboardedHistory";
import DiagnosticData from "../report/DiagnosticData";
import WarrantyInfo from "../report/WarrantyInfo";
import ServiceInfo from "../report/ServiceInfo";
import Dialog from "../Common/Dailog/Dailog";
import AppButton from "../Common/Button/Button";
import EmptyState from "../Common/EmptyState/EmptyState";
import FormInput from "../Common/FormInputs/MuiTextField";
import InfoField from "../Common/InfoField/InfoField";
import {
  offboardDevicebyId,
  updateProductSerialNumberbyID,
  sendMismatchData,
  updateProductModelNumberbyID,
  updateFirmwareVersion,
} from "../../action/report";
import { UserContext } from "../../components/routing/Routes";
import SendingEmail from "../report/SendingEmail";
import isValid from "../../utils/checkProdSerial";
import { getWarrantyDetails } from "../../action/warranty";
import customConfig from "../../config";
import Alert from "../layout/Alert";
import DisplayDeviceDealerDeatils from "../deviceDealerMgmt/deviceDealerDetailsPage";
import { getDeviceDealerInfoByPSN } from "../../action/deviceDealer";
import { setAlert } from "../../action/alert";
import VRFDeviceDetails from "./VRFDeviceDetails";
import { SectionHeading, ValueText } from "../Common/Typography/AppTypography";

const DeviceDetails = ({
  setAlert,
  showSeparator = false,
  device,
  deviceUsage,
  latestFirmwareData,
  firmwareData,
  onBoardedHistoryData,
  notifyOffboard,
  offboardDevicebyId,
  updateProductSerialNumberbyID,
  updateProductModelNumberbyID,
  sendMismatchData,
  getWarrantyDetails,
  diagnosticData,
  updateFirmwareVersion,
  // updateFirmwareRes,
  homeId,
  setIsEdit,
  tenantInfo,
  // updateFirmwareVersion,
  updateFirmwareRes,
  // homeId,
  WarrantyData: { warrantyToken, applianceData, applianceError },
  userRoleInfo,
  /** When true, do not apply negative horizontal margins – used when embedded under SearchDevice */
  compactLayout = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { colors } = useDesignTokens();
  const primaryColor = colors?.primary?.main || theme.palette.primary.main;
  const focusOutlineSx = {
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: `${primaryColor} !important`,
      borderWidth: "1px",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: `${primaryColor} !important`,
    },
  };
  const getDeviceDialogProps = ({
    title,
    wide = false,
    compact = false,
  } = {}) => ({
    open: true,
    onClose: () => {},
    title,
    maxWidth: false,
    fullWidth: isMobile,
    fullScreen: isMobile && wide,
    showCloseButton: true,
    closeOnBackdropClick: true,
    closeOnEscapeKeyDown: true,
    sx: { zIndex: 9999 },
    PaperProps: {
      sx: {
        borderRadius: isMobile && wide ? 0 : 1,
        ...(compact
          ? {
              width: { xs: "calc(100% - 16px)", sm: 680 },
              minWidth: { xs: "unset", sm: 680 },
              maxWidth: { xs: "calc(100vw - 24px)", sm: 680 },
            }
          : wide
            ? {
                minWidth: { xs: "unset", sm: 780 },
                maxWidth: 960,
              }
            : {
                minWidth: { xs: "unset", sm: 600 },
                maxWidth: 760,
              }),
        maxHeight: compact
          ? { xs: "85vh", sm: "70vh" }
          : { xs: "90vh", sm: "90vh" },
        m: { xs: 1, sm: 2 },
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      },
    },
    titleSx: {
      backgroundColor: "#fff",
      color: "#212121",
      py: 1.5,
      px: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
    },
    contentSx: {
      pt: title ? (compact ? 1.5 : 2) : compact ? 2 : 3,
      px: { xs: 2, sm: compact ? 2 : 3 },
      pb: compact ? 2 : 3,
      // Avoid unnecessary horizontal scrollbar while keeping vertical scrolling
      overflowY: "auto",
      overflowX: "hidden",
      flex: "1 1 auto",
      minHeight: 0,
    },
  });
  const userInfo = useContext(UserContext);
  const location = useLocation();
  const [showUsage, setShowUsage] = useState(false);
  const [showFirmwareHistory, setShowFirmwareHistory] = useState(false);
  const [showUpdateProductSerialNo, setShowUpdateProductSerialNo] =
    useState(false);
  const [
    disabledProductSerialUpdateButton,
    setDisabledProductSerialUpdateButton,
  ] = useState(false);
  const [newProductSerialNumber, setNewProductSerialNumber] = useState(
    device.length > 0 ? device[0].productSerialNumber : "",
  );

  const [showUpdateProductModelNo, setShowUpdateProductModelNo] =
    useState(false);
  const [
    disabledProductModelUpdateButton,
    setDisabledProductModelUpdateButton,
  ] = useState(false);
  const [newProductModelNumber, setNewProductModelNumber] = useState(
    device.length > 0 ? device[0].modelNumber : "",
  );
  const [showOnboardedHistory, setShowOnboardedHistory] = useState(false);
  const [showDiagnosticData, setShowDiagnosticData] = useState(false);
  const [showSendingEmailEditor, setShowSendingEmailEditor] = useState(false);
  const [showWarrantyInfo, setShowWarrantyInfo] = useState(false);
  const [showServiceInfo, setShowServiceInfo] = useState(false);
  const [isWarrantyLinkValid, setIsWarrantyLinkValid] = useState(false);
  const [warrantyProducts, setWarrantyProducts] = useState(null);
  const [warrantyError, setWarrantyError] = useState("");
  const [serviceError, setServiceError] = useState("");

  const [deviceDealerInfo, setDeviceDealerInfo] = useState({});
  const [showDeviceDealerInfo, setShowDeviceDealerInfo] = useState(false);

  const [childCount, setChildCount] = useState(0);

  useEffect(() => {
    if (device && device.length > 0) {
      setWarrantyLinkStyle();
    }
  }, [device]);

  useEffect(() => {
    if ((showUpdateProductModelNo || showUpdateProductSerialNo) && setIsEdit) {
      setIsEdit(true);
    } else {
      if (setIsEdit) setIsEdit(false);
    }
  }, [setIsEdit, showUpdateProductModelNo, showUpdateProductSerialNo]);

  useEffect(() => {
    if (
      !(
        userRoleInfo.level === 0 &&
        userRoleInfo.roles.includes(customConfig.roleFactoryAdmin)
      )
    ) {
      if (
        device &&
        device.length > 0 &&
        warrantyToken &&
        applianceData &&
        applianceData.customer_products &&
        applianceData.customer_products.length > 0
      ) {
        let prodSerial = device[0].productSerialNumber;
        let validSerial = isValid(prodSerial);
        let products;
        if (validSerial) {
          products = applianceData.customer_products.filter(
            (p) => p.serial_no === prodSerial,
          );
        } else {
          let modelNumFragments = device[0].modelNumber.split("-");
          let modelNum = modelNumFragments[modelNumFragments.length - 1];
          products = applianceData.customer_products.filter(
            (p) => p.model_name.indexOf(modelNum) !== -1,
          );
        }

        setWarrantyProducts(products);
        //Get Product Details
        for (let i = 0; i < products.length; i++) {
          const prodId = products[i].id;
          getWarrantyDetails(warrantyToken, prodId);
        }

        if (!(products && products.length > 0)) {
          sendWarrantyMismatchData();
        }
      }
    }
  }, [device, warrantyToken, applianceData, isWarrantyLinkValid]);
  function isValidProdSerialNum() {
    return (
      device && device.length > 0 && isValid(device[0].productSerialNumber)
    );
  }

  function setWarrantyLinkStyle() {
    setIsWarrantyLinkValid(isValidProdSerialNum());
  }

  const offboard = (dd) => {
    offboardDevicebyId(dd.deviceId);
    notifyOffboard();
  };

  const handleUsagePopupClose = () => {
    setShowUsage(false);
  };

  const handleHistoryPopupClose = () => {
    setShowFirmwareHistory(false);
  };

  const handleEmailSendingPopupClose = () => {
    setShowSendingEmailEditor(false);
  };

  const handleOnBoardedHistoryPopupClose = () => {
    setShowOnboardedHistory(false);
  };

  const handleDiagnosticDataPopupClose = () => {
    setShowDiagnosticData(false);
  };

  const handleServiceInfoPopupClose = () => {
    setShowServiceInfo(false);
  };

  const handleWarrantyInfoPopupClose = () => {
    setShowWarrantyInfo(false);
  };

  // Visible serial number update form
  const showUpdateProductSerialPopup = () => {
    let prodSerialNo = device[0].productSerialNumber
      ? device[0].productSerialNumber.trim()
      : "";
    setNewProductSerialNumber(prodSerialNo);
    //SIFI-4968 - empty product serial number can also be updated
    //setDisabledProductSerialUpdateButton(prodSerialNo.length <= 0);
    showUpdateProductSerialNo
      ? setShowUpdateProductSerialNo(false)
      : setShowUpdateProductSerialNo(true);
  };

  const cancelSerialPopup = () => {
    setShowUpdateProductSerialNo(false);
    setDisabledProductSerialUpdateButton(false);
  };

  const showUpdateProductModelPopup = () => {
    let prodModelNo = device[0].modelNumber ? device[0].modelNumber.trim() : "";
    setNewProductModelNumber(prodModelNo);
    setDisabledProductModelUpdateButton(prodModelNo.length <= 0);
    showUpdateProductModelNo
      ? setShowUpdateProductModelNo(false)
      : setShowUpdateProductModelNo(true);
  };

  const cancelModelPopup = () => {
    setShowUpdateProductModelNo(false);
    setDisabledProductModelUpdateButton(false);
  };

  // Hit api to update serial number
  const updateProductSerialNumber = () => {
    const updatedProductSerialNo = newProductSerialNumber.trim();
    if (updatedProductSerialNo) {
      updateProductSerialNumberbyID(device[0].deviceId, updatedProductSerialNo);
      setShowUpdateProductSerialNo(false);
      device[0].productSerialNumber = updatedProductSerialNo;
      setWarrantyLinkStyle();
    } else {
      //SIFI-4968 - Update empty product serial number
      updateProductSerialNumberbyID(device[0].deviceId, "");
      setShowUpdateProductSerialNo(false);
      device[0].productSerialNumber = "";
      setWarrantyLinkStyle();
    }
  };
  // Hit api to update model number
  const updateProductModelNumber = () => {
    const updatedProductModelNo = newProductModelNumber.trim();
    if (updatedProductModelNo) {
      updateProductModelNumberbyID(device[0].deviceId, updatedProductModelNo)
        .then(() => {
          device[0].modelNumber = updatedProductModelNo;
          setShowUpdateProductModelNo(false);
          setAlert("Model Number Updated Succesfully", "success");
        })
        .catch((err) => {
          setShowUpdateProductModelNo(false);
          setAlert(
            err?.response?.data?.message ?? "Failed to Update Model Number",
            "danger",
          );
        });
    }
  };

  const handleWarrantyPopup = (viewService = false) => {
    if (!(warrantyProducts && warrantyProducts.length > 0)) {
      if (viewService) {
        setServiceError(customConfig.noServiceDataMsg);
        setShowServiceInfo(true);
      } else {
        setWarrantyError(customConfig.noWarrantyDataMsg);
        setShowWarrantyInfo(true);
      }
      return;
    }
    setWarrantyError("");
    setServiceError("");

    let proceed = true;
    if (!isValidProdSerialNum()) {
      proceed = window.confirm(customConfig.confirmProccedWithoutProdSerial);
    }

    if (proceed) {
      if (viewService) {
        setShowServiceInfo(true);
      } else {
        setShowWarrantyInfo(true);
      }
    }
  };

  const sendWarrantyMismatchData = () => {
    let reqBody = {
      deviceId: device[0].deviceId,
      modelNumber: device[0].modelNumber,
      category: device[0].category,
      productSerialNumber: device[0].productSerialNumber,
      onboardedBy: device[0].onboardedBy,
    };
    sendMismatchData(reqBody);
  };

  const onChange = (e) => {
    //SIFI-4968 - empty product serial number can also be updated
    // if (e.target.value.trim().length > 0)
    //   setDisabledProductSerialUpdateButton(false);
    // else setDisabledProductSerialUpdateButton(true);

    setNewProductSerialNumber(e.target.value);
  };
  const onChangeModel = (e) => {
    if (e.target.value.trim().length > 0)
      setDisabledProductModelUpdateButton(false);
    else setDisabledProductModelUpdateButton(true);

    setNewProductModelNumber(e.target.value);
  };

  const handleVersionUpdate = () => {
    let reqBody = {
      currentFirmwareVersion: device[0]?.firmwareVersion,
      latestFirmwareVersion: latestFirmwareData?.firmwareVersion,
      deviceId: device[0]?.deviceId,
    };
    updateFirmwareVersion(reqBody);
  };

  function handleViewDealerInfo() {
    if (
      device &&
      device[0].productSerialNumber &&
      device[0].productSerialNumber.length > 0
    ) {
      getDeviceDealerInfoByPSN(device[0].productSerialNumber)
        .then((data) => {
          setDeviceDealerInfo(data);
          setShowDeviceDealerInfo(true);
        })
        .catch((err) => {
          setDeviceDealerInfo({});
          setShowDeviceDealerInfo(true);
        });
    }
  }

  const linkStyleSx = {
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.5,
    display: "inline-flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    textDecoration: "underline",
    "&:hover": { textDecoration: "underline" },
  };
  const linkValidSx = { ...linkStyleSx, color: "text.primary" };
  const linkInvalidSx = { ...linkStyleSx, color: "error.main" };
  const renderDetailActionLink = ({ text, onClick, sx = {}, id }) => (
    <ValueText
      component="span"
      id={id}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => e.key === "Enter" && onClick()}
      sx={{ ...linkValidSx, ...sx }}
    >
      {text}
    </ValueText>
  );

  return (
    <Fragment>
      {device && device.length > 0 ? (
        <Box
          sx={{
            position: "relative",
            maxWidth: "100%",
            minWidth: 0,
            overflowX: "hidden",
            ...(compactLayout
              ? {}
              : {
                  ml: -1.5,
                  mr: -1.5,
                }),
          }}
        >
          {homeId && <Alert />}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "flex-start",
              justifyContent: "space-between",
              width: "100%",
              mb: 2,
            }}
          >
            <SectionHeading sx={{ mb: 0 }}>Device Details</SectionHeading>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                justifyContent: "flex-end",
              }}
            >
              <AppButton
                variant="primary"
                size="medium"
                onClick={() => setShowSendingEmailEditor(true)}
              >
                Send Email
              </AppButton>
              {userInfo.level > 1 && (
                <AppButton
                  variant="primary"
                  size="medium"
                  onClick={() => {
                    if (
                      device[0].category ===
                        customConfig.deviceCategoryVRFGateway &&
                      childCount > 0
                    ) {
                      setAlert(customConfig.offboardGatewayAlert, "danger");
                    } else if (window.confirm(customConfig.confirmOffboard)) {
                      offboard(device[0]);
                    }
                  }}
                >
                  Offboard device
                </AppButton>
              )}
              {userInfo.level > 1 &&
                latestFirmwareData.firmwareVersion >
                  device[0].firmwareVersion && (
                  <AppButton
                    variant="primary"
                    size="medium"
                    onClick={() => handleVersionUpdate()}
                  >
                    Send FOTA Trigger
                  </AppButton>
                )}
            </Box>
          </Box>

          <Paper sx={{ p: 0, pt: 2, boxShadow: 2, borderRadius: 1, mb: 2 }}>
            <Grid2 container spacing={3}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <InfoField label="Device ID" value={device[0].deviceId} />
                {!showUpdateProductModelNo ? (
                  <InfoField
                    label="Model Number"
                    onEdit={showUpdateProductModelPopup}
                    showEdit={
                      userInfo.level > 1 ||
                      (userInfo.level === 0 &&
                        userRoleInfo.roles.includes(
                          customConfig.roleFactoryAdmin,
                        ))
                    }
                  >

                    <Link
                       to={`/deviceDetail/${device[0]?.modelNumber}`}
                        state={{
                          from:location.pathname,
                          showBackButton: true,
                          modelId: device?.[0]?.modelId ?? device?.[0]?.modelID,
                        }}
                      
                      style={{
                        color: "inherit",
                        fontWeight: 600,
                        textDecoration: "underline",
                      }}
                    >
                      {device[0].modelNumber}
                    </Link>
                  </InfoField>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      flexWrap: "wrap",
                      mb: 2,
                    }}
                  >
                    <FormInput
                      placeholder="Enter Model Number"
                      value={newProductModelNumber}
                      onChange={onChangeModel}
                      sx={{ minWidth: 200, maxWidth: 320, ...focusOutlineSx }}
                    />
                    <AppButton
                      variant="primary"
                      size="small"
                      disabled={disabledProductModelUpdateButton}
                      onClick={() => updateProductModelNumber()}
                    >
                      Update
                    </AppButton>
                    <AppButton
                      variant="ghost"
                      size="small"
                      onClick={() => cancelModelPopup()}
                    >
                      Cancel
                    </AppButton>
                  </Box>
                )}
                <InfoField label="Mac Address" value={device[0].macAddress} />
                <InfoField
                  label="Serial Number"
                  value={device[0].serialNumber}
                />
                {!showUpdateProductSerialNo ? (
                  <InfoField
                    label="Product Serial Number"
                    onEdit={showUpdateProductSerialPopup}
                    showEdit={
                      !(
                        device[0].onboardedAt && device[0].onboardedAt !== ""
                      ) &&
                      (userInfo.level > 1 ||
                        (userInfo.level === 0 &&
                          userRoleInfo.roles.includes(
                            customConfig.roleFactoryAdmin,
                          )))
                    }
                  >
                    {device[0].productSerialNumber}
                  </InfoField>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      flexWrap: "wrap",
                      mb: 2,
                    }}
                  >
                    <FormInput
                      placeholder="Enter Serial Number"
                      value={newProductSerialNumber}
                      onChange={onChange}
                      sx={{ minWidth: 200, maxWidth: 320, ...focusOutlineSx }}
                    />
                    <AppButton
                      variant="primary"
                      size="small"
                      disabled={disabledProductSerialUpdateButton}
                      onClick={() => updateProductSerialNumber()}
                    >
                      Update
                    </AppButton>
                    <AppButton
                      variant="ghost"
                      size="small"
                      onClick={() => cancelSerialPopup()}
                    >
                      Cancel
                    </AppButton>
                  </Box>
                )}
                <InfoField label="Model Name" value={device[0].modelName} />
                <InfoField
                  label="Manufactured Date"
                  value={
                    device[0].manufacturedDate ? (
                      <Moment
                        format="MMMM Do YYYY, h:mm:ss a"
                        date={device[0].manufacturedDate * 1000}
                      />
                    ) : (
                      "-"
                    )
                  }
                />
                <InfoField
                  label="Firmware Current Version"
                  value={device[0].firmwareVersion}
                />
                {!(
                  userRoleInfo.level == 0 &&
                  userRoleInfo.roles.includes(customConfig.roleFactoryAdmin)
                ) && (
                  <InfoField
                    label="Onboarded By"
                    value={device[0].onboardedBy}
                  />
                )}
                {!(
                  userRoleInfo.level == 0 &&
                  userRoleInfo.roles.includes(customConfig.roleFactoryAdmin)
                ) && (
                  <InfoField label="Onboard/Offboard History">
                    {renderDetailActionLink({
                      text: "View History",
                      onClick: () => setShowOnboardedHistory(true),
                    })}
                    {showOnboardedHistory && (
                      <Dialog
                        {...getDeviceDialogProps({
                          wide: true,
                          title: "Onboard/Offboard History",
                        })}
                        onClose={handleOnBoardedHistoryPopupClose}
                      >
                        <OnboardedHistory
                          onBoardedHistoryData={onBoardedHistoryData}
                          showHeader={false}
                        />
                      </Dialog>
                    )}
                  </InfoField>
                )}
                {!(
                  userRoleInfo.level == 0 &&
                  userRoleInfo.roles.includes(customConfig.roleFactoryAdmin)
                ) &&
                  (device[0].category == customConfig.decviceCategoryAC ||
                    device[0].category == customConfig.deviceCategoryCAC) && (
                    <InfoField label="Diagnostics Data">
                      {renderDetailActionLink({
                        text: "View Data",
                        onClick: () => setShowDiagnosticData(true),
                      })}
                      {showDiagnosticData && (
                        <Dialog
                          {...getDeviceDialogProps({
                            wide: true,
                            title: "Diagnostics Data",
                          })}
                          onClose={handleDiagnosticDataPopupClose}
                        >
                          <DiagnosticData
                            diagnosticData={diagnosticData}
                            deviceID={device[0].deviceId}
                            modelNumber={device[0].modelNumber}
                            showHeader={false}
                          />
                        </Dialog>
                      )}
                    </InfoField>
                  )}
                <InfoField
                  label="Alexa Connected Date"
                  value={
                    device[0].alexaConnectDate ? (
                      <Moment
                        format="MMMM Do YYYY, h:mm:ss a"
                        date={device[0].alexaConnectDate.$date}
                      />
                    ) : (
                      "-"
                    )
                  }
                />
                <InfoField
                  label="Google Home Connected Date"
                  value={
                    device[0].googleHomeConnectDate ? (
                      <Moment
                        format="MMMM Do YYYY, h:mm:ss a"
                        date={device[0].googleHomeConnectDate.$date}
                      />
                    ) : (
                      "-"
                    )
                  }
                />
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <InfoField label="Brand Name" value={device[0].brand} />
                <InfoField
                  label="Created At"
                  value={
                    device[0].createdAt ? (
                      <Moment
                        format="MMMM Do YYYY, h:mm:ss a"
                        date={device[0].createdAt * 1000}
                      />
                    ) : (
                      "-"
                    )
                  }
                />
                <InfoField label="Created By" value={device[0].createdBy} />
                <InfoField label="Category" value={device[0].category} />
                <InfoField
                  label="efuseMacAddress"
                  value={device[0].efuseMacAddress}
                />
                <InfoField
                  label="Provisioned At"
                  value={
                    device[0].provisionedAt ? (
                      <Moment
                        format="MMMM Do YYYY, h:mm:ss a"
                        date={device[0].provisionedAt * 1000}
                      />
                    ) : (
                      "-"
                    )
                  }
                />
                <InfoField
                  label="Onboarded At"
                  value={
                    device[0].onboardedAt ? (
                      <Moment
                        format="MMMM Do YYYY, h:mm:ss a"
                        date={device[0].onboardedAt * 1000}
                      />
                    ) : (
                      "-"
                    )
                  }
                />
                {!(
                  userRoleInfo.level == 0 &&
                  userRoleInfo.roles.includes(customConfig.roleFactoryAdmin)
                ) && (
                  <InfoField
                    label="Latest Firmware Version"
                    value={latestFirmwareData.firmwareVersion}
                  />
                )}
                {!(
                  userRoleInfo.level == 0 &&
                  userRoleInfo.roles.includes(customConfig.roleFactoryAdmin)
                ) && (
                  <InfoField label="Firmware History">
                    {renderDetailActionLink({
                      text: "View History",
                      onClick: () => setShowFirmwareHistory(true),
                    })}
                    {showFirmwareHistory && (
                      <Dialog
                        {...getDeviceDialogProps({
                          wide: true,
                          title: "Firmware History",
                        })}
                        onClose={handleHistoryPopupClose}
                      >
                        <FirmwareDetails
                          firmwareData={firmwareData}
                          deviceID={device[0].deviceId}
                          showHeader={false}
                        />
                      </Dialog>
                    )}
                  </InfoField>
                )}
                {!(
                  userRoleInfo.level == 0 &&
                  userRoleInfo.roles.includes(customConfig.roleFactoryAdmin)
                ) && (
                  <InfoField label="Usage Information">
                    {renderDetailActionLink({
                      text: "View Usage",
                      onClick: () => setShowUsage(true),
                    })}
                    {showUsage && (
                      <Dialog
                        {...getDeviceDialogProps({
                          wide: true,
                          title: "Usage Information",
                        })}
                        onClose={handleUsagePopupClose}
                      >
                        <DeviceUsage
                          deviceId={device[0].deviceId}
                          modelNumber={device[0].modelNumber}
                          deviceUsage={deviceUsage}
                          showHeader={false}
                        />
                      </Dialog>
                    )}
                  </InfoField>
                )}
                {!(
                  userRoleInfo.level == 0 &&
                  userRoleInfo.roles.includes(customConfig.roleFactoryAdmin)
                ) &&
                  tenantInfo.tenantId === "panasonic" && (
                    <InfoField label="Warranty Info">
                      {renderDetailActionLink({
                        text: "View warranty info",
                        onClick: () => handleWarrantyPopup(),
                        sx: isWarrantyLinkValid ? linkValidSx : linkInvalidSx,
                        id: "btnWarranty",
                      })}
                      {showWarrantyInfo && (
                        <Dialog
                          {...getDeviceDialogProps({
                            wide: true,
                            title: "View Warranty Info",
                          })}
                          onClose={handleWarrantyInfoPopupClose}
                        >
                          <WarrantyInfo
                            products={warrantyProducts}
                            showProductInfo={!isValidProdSerialNum()}
                            warrantyError={warrantyError}
                            showHeader={false}
                          />
                        </Dialog>
                      )}
                    </InfoField>
                  )}
                {!(
                  userRoleInfo.level == 0 &&
                  userRoleInfo.roles.includes(customConfig.roleFactoryAdmin)
                ) && (
                  <InfoField label="Service Requests">
                    {renderDetailActionLink({
                      text: "View service requests",
                      onClick: () => handleWarrantyPopup(true),
                      sx: isWarrantyLinkValid ? linkValidSx : linkInvalidSx,
                    })}
                    {showServiceInfo && (
                      <Dialog
                        {...getDeviceDialogProps({
                          wide: true,
                          title: "View Service Requests",
                        })}
                        onClose={handleServiceInfoPopupClose}
                      >
                        <ServiceInfo
                          products={warrantyProducts}
                          showProductInfo={!isValidProdSerialNum()}
                          serviceError={serviceError}
                          showHeader={false}
                        />
                      </Dialog>
                    )}
                  </InfoField>
                )}
                {(device[0].category == customConfig.decviceCategoryAC ||
                  device[0].category == customConfig.deviceCategoryCAC) && (
                  <InfoField
                    label="Errors"
                    value={
                      deviceUsage && deviceUsage.errors
                        ? deviceUsage.errors
                        : "-"
                    }
                  />
                )}
                <InfoField label="Dealer Information">
                  {device[0].productSerialNumber &&
                  device[0].productSerialNumber.length > 0
                    ? renderDetailActionLink({
                        text: showDeviceDealerInfo
                          ? "Hide Dealer Information"
                          : "View Dealer Information",
                        onClick: () =>
                          showDeviceDealerInfo
                            ? setShowDeviceDealerInfo(false)
                            : handleViewDealerInfo(),
                        sx: isWarrantyLinkValid ? linkValidSx : linkInvalidSx,
                        id: "btnViewDealerInfo",
                      })
                    : "-"}
                </InfoField>
                {showSendingEmailEditor &&
                  (() => {
                    const props = getDeviceDialogProps({
                      wide: true,
                      title: "Report Incidence",
                    });
                    return (
                      <Dialog
                        {...props}
                        contentSx={{
                          ...props.contentSx,
                          ...(isMobile && { pb: 4, minHeight: 0 }),
                        }}
                        onClose={handleEmailSendingPopupClose}
                      >
                        <SendingEmail
                          deviceInfo={device[0]}
                          userDetail={userInfo}
                          handleEmailSendingPopupClose={
                            handleEmailSendingPopupClose
                          }
                        />
                      </Dialog>
                    );
                  })()}
              </Grid2>
            </Grid2>
          </Paper>
          <Paper sx={{ p: 0, pt: 2, boxShadow: 2, borderRadius: 1, mb: 2 }}>
            <SectionHeading>Device Status</SectionHeading>
            <Grid2 container spacing={3} sx={{ pb: 2 }}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <InfoField label="Connection Status">
                  {deviceUsage?.onlineStatus === "true" ? (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          bgcolor: "success.main",
                          mr: 1,
                        }}
                      />
                      Online
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          bgcolor: "#808085",
                          mr: 1,
                        }}
                      />
                      Offline
                      {deviceUsage?.connectedTime && (
                        <ValueText
                          component="span"
                          color="text.secondary"
                          sx={{ ml: 1, fontSize: 12 }}
                        >
                          (Last Active:{" "}
                          <Moment
                            format="MMMM Do YYYY, h:mm:ss a"
                            date={
                              deviceUsage?.connectedTime.toString().length < 12
                                ? deviceUsage?.connectedTime * 1000
                                : deviceUsage?.connectedTime
                            }
                          />
                          )
                        </ValueText>
                      )}
                    </Box>
                  )}
                </InfoField>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <InfoField
                  label="Device Current Status"
                  value={deviceUsage?.ps}
                />
              </Grid2>
            </Grid2>
          </Paper>
          {showDeviceDealerInfo && (
            <Dialog
              {...getDeviceDialogProps({
                wide: true,
                title: "Dealer Information",
              })}
              onClose={() => setShowDeviceDealerInfo(false)}
            >
              {deviceDealerInfo && Object.keys(deviceDealerInfo).length > 0 ? (
                <DisplayDeviceDealerDeatils
                  deviceDealerDetails={deviceDealerInfo}
                />
              ) : (
                <EmptyState
                  message="No dealer data available"
                  height="auto"
                  minHeight="180px"
                />
              )}
            </Dialog>
          )}
        </Box>
      ) : null}
      {device &&
        device.length > 0 &&
        device[0].category === customConfig.deviceCategoryVRFGateway && (
          <Box
            className="child-devices-section"
            sx={{
              position: "relative",
              mt: 2,
              mb: 2,
              ...(compactLayout
                ? {}
                : {
                    ml: -1.5,
                    mr: -1.5,
                  }),
            }}
          >
            <SectionHeading>Child Devices</SectionHeading>
            <VRFDeviceDetails
              deviceId={device[0].deviceId}
              setAlert={setAlert}
              onChildCountChange={setChildCount}
              embedded
            />
          </Box>
        )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  WarrantyData: state.warranty,
  // updateFirmwareRes:state.report.updateFirmwareRes,
  tenantInfo: state.tenant.tenantInfo,
  updateFirmwareRes: state.report.updateFirmwareRes,
  userRoleInfo: {
    level: state.auth.userLevel,
    roles: state.auth.userRoles,
  },
});

export default connect(mapStateToProps, (dispatch) => {
  return {
    setAlert: (message, status) => dispatch(setAlert(message, status)),
    offboardDevicebyId: (deviceId) => dispatch(offboardDevicebyId(deviceId)),
    updateProductSerialNumberbyID: (deviceId, psn) =>
      dispatch(updateProductSerialNumberbyID(deviceId, psn)),
    updateProductModelNumberbyID: (deviceId, modelNumber) =>
      dispatch(updateProductModelNumberbyID(deviceId, modelNumber)),
    sendMismatchData: (data) => dispatch(sendMismatchData(data)),
    getWarrantyDetails: (token, productId) =>
      dispatch(getWarrantyDetails(token, productId)),
    updateFirmwareVersion: (body) => dispatch(updateFirmwareVersion(body)),
  };
})(DeviceDetails);
